
import { defineComponent } from "vue";
const LoudspeakerPNG = require("../../assets/images/static/Loudspeaker.png");
const GiftPNG = require("../../assets/images/static/Gift.png");
const MessagePNG = require("../../assets/images/static/Message.png");
import { isValid } from "@/classes/ChekType.ts";
const typeList = {
  loudspeaker: LoudspeakerPNG,
  gift: GiftPNG,
  message: MessagePNG,
};

export default defineComponent({
  name: "Popup",
  props: {
    type: {
      type: String,
      default: "loudspeaker",
      validator: function (value: string) {
        return Object.keys(typeList).indexOf(value) !== -1;
      },
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    function closePopup() {
      emit("close");
    }
    function copyKey(event: any, code: string) {
      event.target.parentNode.childNodes[0].select();
      document.execCommand("copy");
      window.MobileApp.call(code, "copy");
    }
    return { typeList, closePopup, copyKey, isValid };
  },
});
